import axios from 'axios';

const getOrderReportsApi = async (paramsFilter, token, langIsoCode) => {
  try {
    const url = `/SaloonOrder/getComplaints/${paramsFilter?.id}`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getOrderReportsApi;
